<div mat-dialog-title style="margin:0px; color: #A20000; text-align: center;">
    <span>Warning</span>
    <div style="font-size:14px;">
        <span>Preferences for this class have been set to default values</span>
    </div>
</div>

<mat-dialog-content>
    <div style="padding-bottom:10px;">
        <span>
            On the next screen, please review the current settings. Pay special attention to the settings for <b>Grade
                Calculation</b> and <b>Rounding</b>.
        </span>
    </div>

    <div>
        <span>
            NOTE: Preferences can be changed at any time by clicking the Preferences button in the bottom bar or
            selecting Preferences from the User Menu.
        </span>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex-footer-right">
        <tyl-button id="initPreferencesNextButton" image="next arrow.png" label="Next" (clickEvent)="nextClick()"></tyl-button>
    </div>
</mat-dialog-actions>